export default __webpack_public_path__ + "static/media/no-image.9dc65a7f.jpg";